import {
  addYears,
  differenceInMonths,
  differenceInYears,
  isValid,
  parse,
  subMonths,
  subYears,
} from 'date-fns'
import { useState } from 'react'
import Content from '../elements/Content'
import { BardDateOfBirthChecker as BardDateOfBirthCheckerType } from '@/src/@types/statamic'
import { DateInput } from '@/src/components/core/DateInput'
import { formatGerman } from '@/src/components/core/lib/date'

export default function BardDateOfBirthChecker({
  optional_title,
  type: _type,
  ...texts
}: BardDateOfBirthCheckerType) {
  const [dateOfBirth, setDateOfBirth] = useState('')
  const isCompleteDate = dateOfBirth.length === 10
  const parsedDate = isCompleteDate
    ? parse(dateOfBirth, 'dd.MM.yyyy', new Date())
    : new Date()
  const age = differenceInYears(new Date(), parsedDate)
  const isValidDate = age > 0 && age < 100
  const earliestTheoryExam = addYears(parsedDate, 17)
  const earliestTheoryExamAdjusted = subMonths(earliestTheoryExam, 1)
  const earliestTheoryExamRequest = subMonths(earliestTheoryExamAdjusted, 1)
  const earliestPracticalExam = addYears(parsedDate, 18)

  const text =
    isValidDate && isCompleteDate && isValid(parsedDate)
      ? determineText(parsedDate, texts)
      : ''

  const replacePlaceholders = (text?: string) =>
    (text || '')
      .replace(
        '{{theory}}',
        formatGerman(earliestTheoryExamAdjusted, 'dd.MM.yyyy')
      )
      .replace(
        '{{practical}}',
        formatGerman(earliestPracticalExam, 'dd.MM.yyy')
      )
      .replace(
        '{{theoryRequest}}',
        formatGerman(earliestTheoryExamRequest, 'dd.MM.yyyy')
      )

  return (
    <div className="max-w-prose">
      <div className="rounded-lg bg-gradient-100 p-12">
        <div className="grid grid-cols-2 gap-6">
          <label htmlFor="dateOfBirth" className="block text-xl font-bold">
            {optional_title}
          </label>
          <DateInput
            id="dateOfBirth"
            label="Geburtsdatum"
            color="white"
            onChange={(event) => setDateOfBirth(event.currentTarget.value)}
          />
        </div>
        {text && (
          <div className="mt-12">
            <Content content={replacePlaceholders(text)} />
          </div>
        )}
      </div>
    </div>
  )
}

function determineText(
  dateOfBirth: Date,
  {
    almost_out_of_range,
    out_of_range,
    in_range,
    not_in_range,
  }: Omit<BardDateOfBirthCheckerType, 'title' | 'type'>
) {
  const age = differenceInYears(new Date(), dateOfBirth)

  const monthsUntilOutOfRange = differenceInMonths(
    dateOfBirth,
    subYears(new Date(), 20)
  )
  if (age < 17) {
    return not_in_range
  }

  if (age < 20 && monthsUntilOutOfRange > 2) {
    return in_range
  }

  if (monthsUntilOutOfRange <= 2 && age < 20) {
    return almost_out_of_range
  }

  return out_of_range
}
